exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".popup-table-content{\r\n    background-color: #00d7c6 !important;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/loan/apply-loan-model-popup/apply-loan-model-popup.component.css
// module id = 629
// module chunks = 8